// Fase 5 i18n bundle — Open Data landing, Admin, Documentación
import i18n from "@/i18n";

const GL = {
  sidebar_admin: "Admin",
  sidebar_documentacion: "Documentación",

  // Public Open Data landing
  od_title: "Datos Abertos",
  od_subtitle: "Catálogo público de datos da plataforma Salnés Sostible",
  od_intro: "Datos institucionais dispoñibles baixo licenza CC BY 4.0. Descargables en JSON, CSV e GeoJSON. Cita suxerida en cada dataset.",
  od_datasets: "Datasets",
  od_docs_api: "Documentación técnica da API",
  od_get_key: "Solicitar API key",
  od_license: "Licenza",
  od_frequency: "Frecuencia",
  od_formats: "Formatos",
  od_records: "Rexistros",
  od_download: "Descargar",
  od_how_title: "Como usar a API",
  od_how_body: "Fai peticións HTTP GET aos endpoints. Sen key: 60 peticións/hora por IP. Con cabeceira X-API-Key: 1000/hora.",

  // Documentación pública
  doc_title: "Documentación",
  doc_subtitle: "Guía de uso e memoria técnica de Salnés Sostible",
  doc_about: "Sobre a plataforma",
  doc_about_body: "Salnés Sostible é a plataforma DTI/PID de indicadores territoriais para os 3 concellos con recollida activa da Mancomunidade do Salnés (Cambados, Meis e Vilanova de Arousa). Financiada pola UE — NextGenerationEU no marco do PRTR.",
  doc_modules: "Módulos",
  doc_roles: "Roles e permisos",
  doc_sources: "Datos e fontes",
  doc_downloads: "Descargas",
  doc_download_user: "Manual de usuario (PDF)",
  doc_download_tech: "Memoria técnica (PDF)",
  doc_download_openapi: "OpenAPI spec (JSON)",
  doc_download_swagger: "Swagger UI",

  // Admin
  adm_title: "Admin",
  adm_subtitle: "Xestión da plataforma (só ADMIN)",
  adm_tab_users: "Usuarios",
  adm_tab_keys: "API keys",
  adm_tab_config: "Configuración",
  adm_tab_tasks: "Tarefas",
  adm_tab_api: "Exposición API",
  adm_tab_textos: "Textos institucionais",
  adm_user_new: "Novo usuario",
  adm_user_email: "Email",
  adm_user_name: "Nome",
  adm_user_role: "Rol",
  adm_user_password: "Contrasinal",
  adm_user_active: "Activo",
  adm_user_last_login: "Último acceso",
  adm_user_actions: "Accións",
  adm_user_edit: "Editar",
  adm_user_deactivate: "Desactivar",
  adm_user_created: "Usuario creado",
  adm_user_updated: "Actualizado",
  adm_user_deactivated: "Desactivado",
  adm_user_error: "Erro na operación",
  adm_users_empty: "Non hai usuarios adicionais rexistrados.",
  adm_loading: "Cargando…",
  adm_key_new: "Nova API key",
  adm_key_name: "Nome",
  adm_key_owner: "Email propietario",
  adm_key_created: "Creada o",
  adm_key_last_used: "Último uso",
  adm_key_requests: "Peticións",
  adm_key_active: "Activa",
  adm_key_revoke: "Revogar",
  adm_key_issued: "Chave emitida",
  adm_key_copy_warning: "Copia esta chave agora — non se volverá amosar.",
  adm_key_copied: "Copiada ao portapapeis",
  adm_config_baseline: "Ano base cálculos MRV",
  adm_config_consumption: "Consumo medio l/km",
  adm_config_contact_email: "Email contacto",
  adm_config_contact_phone: "Teléfono contacto",
  adm_config_name_gl: "Nome plataforma (GL)",
  adm_config_name_es: "Nome plataforma (ES)",
  adm_config_save: "Gardar",
  adm_config_saved: "Configuración gardada",
  adm_tasks_intro: "Dispara manualmente as tarefas de sincronización. Rexístranse en audit_events.",
  adm_task_run: "Executar",
  adm_task_running: "Executando…",
  adm_task_ok: "Tarefa completada",
  adm_task_last: "Últimos resultados",
  adm_cancel: "Cancelar",
  adm_confirm: "Confirmar",
  adm_confirm_deactivate: "Confirmas desactivar {{email}}?",

  // SHA verify
  sha_verify: "Verificar integridade (SHA-256)",
  sha_verify_desc: "Sobe o PDF para verificar que coincide co orixinal xerado pola plataforma.",
  sha_expected: "SHA-256 esperado",
  sha_upload: "Subir PDF para comparar",
  sha_match_ok: "Coincide — PDF auténtico.",
  sha_match_fail: "Non coincide — PDF alterado.",
  sha_close: "Pechar",
};

const ES = {
  sidebar_admin: "Admin",
  sidebar_documentacion: "Documentación",

  od_title: "Datos Abiertos",
  od_subtitle: "Catálogo público de datos de la plataforma Salnés Sostenible",
  od_intro: "Datos institucionales disponibles bajo licencia CC BY 4.0. Descargables en JSON, CSV y GeoJSON. Cita sugerida en cada dataset.",
  od_datasets: "Datasets",
  od_docs_api: "Documentación técnica de la API",
  od_get_key: "Solicitar API key",
  od_license: "Licencia",
  od_frequency: "Frecuencia",
  od_formats: "Formatos",
  od_records: "Registros",
  od_download: "Descargar",
  od_how_title: "Cómo usar la API",
  od_how_body: "Haz peticiones HTTP GET a los endpoints. Sin key: 60 peticiones/hora por IP. Con cabecera X-API-Key: 1000/hora.",

  doc_title: "Documentación",
  doc_subtitle: "Guía de uso y memoria técnica de Salnés Sostenible",
  doc_about: "Sobre la plataforma",
  doc_about_body: "Salnés Sostenible es la plataforma DTI/PID de indicadores territoriales para los 3 municipios con recogida activa de la Mancomunidad do Salnés (Cambados, Meis y Vilanova de Arousa). Financiada por la UE — NextGenerationEU en el marco del PRTR.",
  doc_modules: "Módulos",
  doc_roles: "Roles y permisos",
  doc_sources: "Datos y fuentes",
  doc_downloads: "Descargas",
  doc_download_user: "Manual de usuario (PDF)",
  doc_download_tech: "Memoria técnica (PDF)",
  doc_download_openapi: "OpenAPI spec (JSON)",
  doc_download_swagger: "Swagger UI",

  adm_title: "Admin",
  adm_subtitle: "Gestión de la plataforma (solo ADMIN)",
  adm_tab_users: "Usuarios",
  adm_tab_keys: "API keys",
  adm_tab_config: "Configuración",
  adm_tab_tasks: "Tareas",
  adm_tab_api: "Exposición API",
  adm_tab_textos: "Textos institucionales",
  adm_user_new: "Nuevo usuario",
  adm_user_email: "Email",
  adm_user_name: "Nombre",
  adm_user_role: "Rol",
  adm_user_password: "Contraseña",
  adm_user_active: "Activo",
  adm_user_last_login: "Último acceso",
  adm_user_actions: "Acciones",
  adm_user_edit: "Editar",
  adm_user_deactivate: "Desactivar",
  adm_user_created: "Usuario creado",
  adm_user_updated: "Actualizado",
  adm_user_deactivated: "Desactivado",
  adm_user_error: "Error en la operación",
  adm_users_empty: "No hay usuarios adicionales registrados.",
  adm_loading: "Cargando…",
  adm_key_new: "Nueva API key",
  adm_key_name: "Nombre",
  adm_key_owner: "Email propietario",
  adm_key_created: "Creada el",
  adm_key_last_used: "Último uso",
  adm_key_requests: "Peticiones",
  adm_key_active: "Activa",
  adm_key_revoke: "Revocar",
  adm_key_issued: "Clave emitida",
  adm_key_copy_warning: "Copia esta clave ahora — no se volverá a mostrar.",
  adm_key_copied: "Copiada al portapapeles",
  adm_config_baseline: "Año base cálculos MRV",
  adm_config_consumption: "Consumo medio l/km",
  adm_config_contact_email: "Email contacto",
  adm_config_contact_phone: "Teléfono contacto",
  adm_config_name_gl: "Nombre plataforma (GL)",
  adm_config_name_es: "Nombre plataforma (ES)",
  adm_config_save: "Guardar",
  adm_config_saved: "Configuración guardada",
  adm_tasks_intro: "Dispara manualmente las tareas de sincronización. Se registran en audit_events.",
  adm_task_run: "Ejecutar",
  adm_task_running: "Ejecutando…",
  adm_task_ok: "Tarea completada",
  adm_task_last: "Últimos resultados",
  adm_cancel: "Cancelar",
  adm_confirm: "Confirmar",
  adm_confirm_deactivate: "¿Confirmas desactivar {{email}}?",

  sha_verify: "Verificar integridad (SHA-256)",
  sha_verify_desc: "Sube el PDF para verificar que coincide con el original generado por la plataforma.",
  sha_expected: "SHA-256 esperado",
  sha_upload: "Subir PDF para comparar",
  sha_match_ok: "Coincide — PDF auténtico.",
  sha_match_fail: "No coincide — PDF alterado.",
  sha_close: "Cerrar",
};

i18n.addResourceBundle("gl", "common", { fase5: GL }, true, true);
i18n.addResourceBundle("es", "common", { fase5: ES }, true, true);

export default {};
